import React from "react";
import { Theme, useTheme, css } from "@emotion/react";

import Title from "core/Components/Title";

type Props = {
    children: React.ReactNode
};

const PageHeader: React.FC<Props> = ({ children }) => {
    const theme: Theme = useTheme();

    const headerStyle = css`
        font-weight: ${theme.fonts.weights.bold};
        color: ${theme.colours.codGray};
        font-size: 35px;
        line-height: 30px;

        ${theme.breakpoints.up("5xl")} {
            font-size: 40px;
            line-height: 41px;
        }

        ${theme.breakpoints.only("xl")} {
            font-size: 30px;
            line-height: 26px;
        }

        ${theme.breakpoints.down("lg")} {
            font-size: 25px;
            line-height: 21px;
        }
    `;

    return (
        <Title css={headerStyle}>
            {children}
        </Title>
    );
}

export default PageHeader;
